import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { provideValueAccessor } from '@sama/ng-core';
import { AbstractWrappedFormControl } from '../../../../cross-team-shared/forms/basic-inputs/abstract-wrapped-form-control';

@Component({
  selector: 'h3-number-input',
  templateUrl: './number-input.component.html',
  providers: [provideValueAccessor(NumberInputComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NumberInputComponent extends AbstractWrappedFormControl<
  number | null,
  string | null
> {
  @Input() size?: string;
  @Input() addonText?: string;
  @Input() min = 0;
  @Input({ required: true }) max!: number;
  @Input() step?: number;

  protected innerToOuter(value: string | null) {
    return value === null ? null : +value;
  }

  protected outerToInner(value: number | null) {
    return value === null ? null : '' + value;
  }
}
